module.exports = __webpack_public_path__ + "img/supermercado.71b73fe3.svg";